// const ip = 'http://192.168.1.70:8081/wms';
const ip = 'https://www.kaixinfo.com/scrmapi/';
const webIp = 'wss://www.kaixinfo.com/scrmapi/';

// const ip = 'http://192.168.1.70:8081/scrmapi/';
// const webIp = 'ws://192.168.1.70:8081/scrmapi/';
export  default { ip,webIp }
